import React from 'react';
import classnames from 'classnames';
import addToMailchimp from 'gatsby-plugin-mailchimp';

import * as styles from './newsletter.module.scss';
import Button from '../ui/button/button';

interface NewsletterProps {
  className?: string;
}

const Newsletter = ({ className }: NewsletterProps) => {
  const [email, setEmail] = React.useState('');
  const [result, setResult] = React.useState<string | undefined>(undefined);

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    try {
      const resp = await addToMailchimp(email);
      if (resp.result === 'error') {
        throw new Error(`Unable to subscribe. ${resp?.msg}`);
      }
      setResult(resp?.msg);
    } catch {
      setResult('Sorry, something went wrong');
    }
  };

  return (
    <form
      className={classnames(styles.root, className)}
      method="post"
      onSubmit={e => handleSubmit(e)}
    >
      <label htmlFor="email">Email updates:</label>
      {result ? (
        <p>{result}</p>
      ) : (
        <>
          <input
            type="email"
            name="email"
            placeholder="Email address"
            onChange={e => setEmail(e.currentTarget.value)}
          />
          <Button className={styles.button} type="submit">
            Sign up
          </Button>
        </>
      )}
    </form>
  );
};

export default Newsletter;
